// extracted by mini-css-extract-plugin
export var label = "_dp-5";
export var slideContainer = "_dp-0";
export var slider = "_dp-1";
export var sliderLg = "_dp-4";
export var sliderMd = "_dp-3";
export var sliderSm = "_dp-2";